<script setup>
defineProps({
  checked: {
    type: Boolean,
    required: true,
  },
});
</script>
<template>
  <button
    type="button"
    class="w-6 h-6 border flex items-center justify-center cursor-pointer focusVisible rounded"
    :class="{
      'border-neutral-700': !checked,
      'gradient primary border-none': checked,
      'bg-darkOcean-600 text-neutral-0 border-none': checked,
    }"
  >
    <fa-icon class="text-white text-l" :icon="['far', 'check']" />
  </button>
</template>
